<template>
    <circle-progress :percent="percent"
    :size="45"
    :border-width="5"
    :border-bg-width="5"
    :show-percent="true"
    :is-gradient="true"
        :gradient="{
          angle: 90,
          startColor: '#D12158',
          stopColor: '#D12158'
      }"
    />
</template>

<script>
 import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
export default {
    components: {CircleProgress},
    props:['percent'],
}
</script>

<style scoped>
</style>